import { createAvatar } from "@dicebear/core";
import { avataaars } from "@dicebear/collection";

// Map our stored option object to DiceBear avataaars params.
function toDiceBear(opts = {}) {
  const o = {};
  if (opts.skinColor) o.skinColor = [opts.skinColor];
  if (opts.hairColor) o.hairColor = [opts.hairColor];
  if (opts.clothesColor) o.clothesColor = [opts.clothesColor];
  if (opts.eyes) o.eyes = [opts.eyes];
  if (opts.eyebrows) o.eyebrows = [opts.eyebrows];
  if (opts.mouth) o.mouth = [opts.mouth];
  if (opts.top) o.top = [opts.top];
  if (opts.clothing) o.clothing = [opts.clothing];

  if (opts.accessories && opts.accessories !== "none") {
    o.accessories = [opts.accessories];
    o.accessoriesProbability = 100;
  } else {
    o.accessoriesProbability = 0;
  }

  if (opts.facialHair && opts.facialHair !== "none") {
    o.facialHair = [opts.facialHair];
    o.facialHairProbability = 100;
    if (opts.facialHairColor) o.facialHairColor = [opts.facialHairColor];
  } else {
    o.facialHairProbability = 0;
  }

  o.backgroundColor = opts.backgroundColor && opts.backgroundColor !== "transparent"
    ? [opts.backgroundColor]
    : ["transparent"];
  return o;
}

const _cache = {};

// Returns a data-uri SVG for the given avatar options.
export function avatarDataUri(opts, size = 96) {
  const key = size + JSON.stringify(opts || {});
  if (_cache[key]) return _cache[key];
  const uri = createAvatar(avataaars, {
    size,
    radius: 50,
    ...toDiceBear(opts),
  }).toDataUri();
  _cache[key] = uri;
  return uri;
}

export const DEFAULT_AVATAR_OPTIONS = {
  skinColor: "edb98a",
  hairColor: "2c1b18",
  top: "shortFlat",
  eyes: "default",
  eyebrows: "defaultNatural",
  mouth: "smile",
  clothing: "shirtCrewNeck",
  clothesColor: "65c9ff",
  accessories: "none",
  facialHair: "none",
  facialHairColor: "2c1b18",
  backgroundColor: "65c9ff",
};
